import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Spaces from "@/pages/Spaces";
import SpaceDetail from "@/pages/SpaceDetail";
import BookingFlow from "@/pages/BookingFlow";
import MemberDashboard from "@/pages/MemberDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReports from "@/pages/AdminReports";
import AdminMembers from "@/pages/AdminMembers";
import AdminSpaces from "@/pages/AdminSpaces";
import AdminCMS from "@/pages/AdminCMS";
import AdminManagers from "@/pages/AdminManagers";
import RoomDisplay from "@/pages/RoomDisplay";
import OverviewDisplay from "@/pages/OverviewDisplay";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ManagerDashboard from "@/pages/ManagerDashboard";
import AdminGuide from "@/pages/AdminGuide";
import ManagerGuide from "@/pages/ManagerGuide";
import MemberGuide from "@/pages/MemberGuide";
import Profile from "@/pages/Profile";
import BrandGuide from "@/pages/BrandGuide";
import TransitionGuide from "@/pages/TransitionGuide";
import GuestRegister from "@/pages/GuestRegister";
import KioskCheckin from "@/pages/KioskCheckin";
import GuestCheckin from "@/pages/GuestCheckin";

function GATracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function AppLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)]">
        <Outlet />
      </main>
    </>
  );
}

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const interval = setInterval(removeBadge, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <GATracker />
          <Routes>
            <Route path="/display/:spaceId" element={<RoomDisplay />} />
            <Route path="/display-overview" element={<OverviewDisplay />} />
            <Route path="/guest-register" element={<GuestRegister />} />
            <Route path="/kiosk" element={<KioskCheckin />} />
            <Route path="/guest-checkin/:guestId" element={<GuestCheckin />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/spaces" element={<Spaces />} />
              <Route path="/spaces/:id" element={<SpaceDetail />} />
              <Route path="/book/:spaceId" element={<BookingFlow />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dashboard" element={<MemberDashboard />} />
              <Route path="/manager" element={<ManagerDashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/reports" element={<AdminReports />} />
              <Route path="/admin/members" element={<AdminMembers />} />
              <Route path="/admin/spaces" element={<AdminSpaces />} />
              <Route path="/admin/managers" element={<AdminManagers />} />
              <Route path="/admin/cms" element={<AdminCMS />} />
              <Route path="/admin/guide" element={<AdminGuide />} />
              <Route path="/manager/guide" element={<ManagerGuide />} />
              <Route path="/member/guide" element={<MemberGuide />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/brand" element={<BrandGuide />} />
              <Route path="/transition" element={<TransitionGuide />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </>
  );
}

export default App;
